import React from 'react'
import MatchedBusinessesInfo from 'common/components/job_wizard/MatchedBusinessesInfo'
import { Job, JobWizard } from 'sprockets_react/job_wizards/registries'
import $ from 'sprockets_react/job_wizards/jquery'

JobWizard.EmailAddress = {
  displayName: 'EmailAddress',
  newExisingUserStore: { existingUser: false, newUser: false },
  errorMessage: '',
  passwordValidationError: '',

  onSubmit: function(onStepProgression, onRequest, onRequestCompletion, onStepRetreat) {
    let emailCheck = () => {
      $.ajax(SS.API.V3.userCheckEmail(Job.Data.emailAddress)).fail(function () {
        document.location = "/500"
      }).done((response) => {
        const result = response.meta

        if (result.status === 'true') {
          this.newExisingUserStore = { existingUser: true, newUser: false }
          Job.Actions.updatePhoneNumber(result.phone)
          JobWizard.Emitter.emit('job:wizard:existingUser', {...this.newExisingUserStore, ...{isEmailDisabled: true}})
          JobWizard.Validator.resetForm()
        }
        else if (result.status === 'valid') {
          this.newExisingUserStore = { existingUser: false, newUser: true }
          JobWizard.Emitter.emit('job:wizard:existingUser', {...this.newExisingUserStore, ...{isEmailDisabled: true}})
          JobWizard.Validator.resetForm()
        }
        else {
          JobWizard.Validator.updateMessage('email_address', 'notEmpty', result.error || 'Please enter a valid email address.')
          JobWizard.Validator.updateStatus('email_address', 'INVALID', 'notEmpty')
        }
      })
    }

    let createAccount = () => {
      let $createAccount = $('.create-account')
      let subscribeToMessages = true

      var userObj = SS.API.V3.userCreate(
        {
          email: Job.Data.emailAddress,
          name: $createAccount.find('#first-name').val(),
          phone: $createAccount.find('#contact-phone').val(),
          'autogenerate-password': true
        },
        {
          type: 'email-preferences',
          attrs: {
            'ss-update': subscribeToMessages,
            'sms-offers': subscribeToMessages
          }
        });

      userObj.beforeSend = onRequest

      $.ajax(userObj)
        .always(onRequestCompletion)
        .done(function (data) {
          // send to token to mobile app
          onStepProgression()
          SS.appFn.appMsg({ id: data.data.id, token: data.meta.token, version: '1.1' })
          $('#user-session-id').attr('title', data.data.id)
          SS.currentUserId = data.data.id
          SS.userPhoneIsValid = data.meta.validPhone
          SS.userPhoneVerified = data.meta.verifiedPhone

          if (SS.appFn.userHasPhoneForCurrentFlow() === true) {
            JobWizard.StepSequence.removeStepByType(JobWizard.Contact)
          }
        })
        .fail((data) => {
          if (data.status === 422) {
            let res = data.responseJSON
            for (let i = 0; i < res.errors.length; i++) {
              this.errorMessage = this.errorMessage += ' ' + res.errors[i].detail
            }

            this.newExisingUserStore = { existingUser: false, newUser: true }
            JobWizard.Emitter.emit('job:wizard:existingUser', {...this.newExisingUserStore, ...{isEmailDisabled: true}})
            JobWizard.Validator.resetForm()

          } else {
            this.errorMessage = 'Sorry we are unable to process your request at this time. Please try again later.'
            document.location.href = '/500'
            onRequestCompletion()
          }
        })
    }

    let newPasswordCheck = () => {
      let newPassword = $("#new-password").val();
      let confirmPassword = $("#confirm-password").val();
      let error = ''

      if (newPassword !== '' && newPassword !== null ) {
        if (newPassword && newPassword.length < 6) {
          error = 'Password is too short (min 6 characters).'
        } else if (newPassword && newPassword.length > 40) {
          error = 'Password is too long (max 40 characters).'
        } else if (newPassword !== confirmPassword) {
          error = 'Passwords do not match.'
        }

        JobWizard.Emitter.emit('job:wizard:passwordError', error)
        if (newPassword.length < 6 || newPassword.length > 40 || newPassword !== confirmPassword || confirmPassword.length < 6) return

        $.ajax(SS.API.V3.userPasswordReset({
          email: Job.Data.emailAddress,
          pin: Job.Data.otp,
          password: newPassword,
          password_confirmation: confirmPassword
        })).done((data) => {
          Job.PostingProgressActions.updateTracking({ UserLoggedIn: true });
          $('#user-session-id').attr('title', data.data.id)
          SS.currentUserId = data.data.id

          onStepProgression()
        }).fail(() => {
          document.location.href = '/500'
        })
      }
    }

    let checkPhoneValidation = () => {
      let validationUrl = Job.Data.phoneVerificationRequired ? '/users/validate_mobile_contact_phone' : '/users/validate_contact_phone'

      $.ajax({
        url: validationUrl,
        dataType: 'json',
        data: { user_attributes: {
                  contact_phone: JobWizard.Validator.getFieldElements('contact_phone').val()
                }
              }
      }).fail(function (error) {
        document.location = "/500"
      }).done((result) => {
        if (result.valid) {
          JobWizard.Validator.isValidField('first_name') &&
            JobWizard.Validator.isValidField('contact_phone') &&
            createAccount()
        } else {
          JobWizard.Validator.updateMessage('contact_phone', 'notEmpty', result.error_message)
          JobWizard.Validator.updateStatus('contact_phone', 'INVALID', 'notEmpty')
        }
      })
    }

    if (Job.Data.omniAuthDetails['oauth_email_exists'] === true) {
      this.newExisingUserStore = { existingUser: true, newUser: false }
      JobWizard.Validator.validateField('password')
      JobWizard.Validator.isValidField('password') && passwordCheck()
    } else if (Job.Data.omniAuthDetails['account_from_omni_auth'] === true) {
      Job.PostingProgressActions.updateTracking({ UserLoggedIn: true })
      onStepProgression()
      SS.appFn.appMsg({ id: Job.Data.omniAuthDetails["user_session_id"], version: '1.1' })
      $('#user-session-id').attr('title', Job.Data.omniAuthDetails["user_session_id"])
      SS.currentUserId = Job.Data.omniAuthDetails["user_id"]
      SS.appFn.userPhoneIsValid = true
      SS.userPhoneVerified = false
    } else if (Job.Data.otp !== null && Job.Data.otp !== '') {
      newPasswordCheck()
    } else if (this.newExisingUserStore.existingUser) {
      $('.other-login').addHidden()
      JobWizard.Validator.validateField('password')
      JobWizard.Validator.isValidField('password') && passwordCheck()
    } else if (this.newExisingUserStore.newUser) {
      $('.other-login').addHidden()
      JobWizard.Validator.validateField('first_name')
      JobWizard.Validator.validateField('contact_phone')
      checkPhoneValidation()
    } else {
      $('.other-login').addHidden()
      JobWizard.Validator.validateField('email_address')
      JobWizard.Validator.isValidField('email_address') && emailCheck()
    }

    function passwordCheck(params) {
      var sessionObj = SS.API.V3.userSession({
        email: Job.Data.emailAddress,
        password: $('.job-modal-step #password').val(),
        reauth: true
      })

      sessionObj.beforeSend = onRequest // changes wizard loading state to true for the spinner

      $.ajax(sessionObj)
        .always(function () {
          onRequestCompletion() // changes wizard loading state to false or remove spinner
        })
        .done((data) => {
          Job.PostingProgressActions.updateTracking({ UserLoggedIn: true })
          // send to token to mobile apps
          if (Job.Data.omniAuthDetails['oauth_email_exists']) {
            attachOmniAuthToUser()
          }

          SS.appFn.appMsg({ id: data.data.id, token: data.meta.token, version: '1.1' })
          Job.Actions.updatePhoneNumber(data.data.attributes.phone || '')
          $('#user-session-id').attr('title', data.data.id)
          SS.currentUserId = data.data.id
          SS.userPhoneIsValid = data.meta.validPhone
          SS.userPhoneVerified = data.meta.verifiedPhone
          onStepProgression()
        })
        .fail(function (xhr, textStatus, errorThrown) {
          if (xhr.status === 401 || xhr.status === 422) {
            let errorMessage = xhr.responseJSON.errors[0].detail

            this.newExisingUserStore = { existingUser: true, newUser: false }
            JobWizard.Emitter.emit('job:wizard:existingUser', {...this.newExisingUserStore, ...{isEmailDisabled: true}})

            JobWizard.Validator.resetForm()
            $('.incorrect-password').rmHidden()
            $('.reset-password').css('marginRight', '90px')
          } else {
            document.location.href = '/500'
          }
        })

        function attachOmniAuthToUser(){
          $.ajax({
            url: '/users/auth/attach_oauth_uid',
            dataType: 'json',
            method: 'POST',
            data: {
                    user_id: Job.Data.omniAuthDetails['user_id'],
                    oauth_uid: Job.Data.omniAuthDetails['oauth_uid'],
                    oauth_provider: Job.Data.omniAuthDetails['oauth_provider'],
                  }
          })
        }
    }
  },

  // ---------------------------------------------------------------------------- component start --------------------------------------------------------------------------------------------
  component: React.createClass({
    getInitialState: function() {
      return {
        emailAddress: Job.Data.emailAddress,
        existingUser: false,
        newUser: false,
        isEmailDisabled: false
      }
    },

    componentDidMount: function() {
      JobWizard.Emitter.addListener('job:wizard:existingUser', this.updateNewOrExistingUserState)
      if (Job.Data.omniAuthDetails['account_from_omni_auth'] === false) {
        this.setupValidation()
      }

      Job.Actions.updateResetEmailAddressSlide(false)
    },

    componentWillUnmount: function() {
      JobWizard.Emitter.removeListener('job:wizard:existingUser', this.updateNewOrExistingUserState)
    },

    setupValidation: function () {
      const wizard = JobWizard;
      wizard.Validator.addField('email_address', {
        threshold: 9999999,
        validators: {
          notEmpty: {
            message: 'Please enter an email address'
          }
        }
      })

      wizard.Validator.$form.on('error.field.bv', function(e, data) {
        data.element
          .data('bv.messages')
          .find('[data-bv-validator="' + data.validator + '"]').show()
      })
    },

    updateNewOrExistingUserState: function(args) {
      this.setState(args)
    },

    handleEmailAddressChange: function(e) {
      JobWizard.EmailAddress.newExisingUserStore = { existingUser: false, newUser: false } //reset local object store when user changes email
      let emailAddressOriginal = e.target.value
      let emailAddressTrimmed = e.target.value.replace(/[\s]/g, '')

      if (emailAddressOriginal !== emailAddressTrimmed) {
        e.target.value = emailAddressTrimmed
      }

      this.setState({ emailAddress: emailAddressTrimmed })
      Job.Actions.updateEmailAddress(emailAddressTrimmed)
      Job.Actions.updateOtp(null)
      Job.Actions.updateOmniAuthDetails({})
      Job.Actions.updateOmniAuthDetails({'account_from_omni_auth': false})

    },

    render: function() {
      return (
        <div>
          <MatchedBusinessesInfo
            subcategoryId={Job.Data.category_id}
            subcategoryName={Job.Data.category}
            suburbId={Job.Data.suburb_id}
            suburbName={Job.Data.suburb}
          />
          { Job.Data.omniAuthDetails['account_from_omni_auth'] === false &&
            <div>
              <h3 className="mb15 mt10">Which email do you want to get alerts about your job?</h3>
              <small className="info-text">
                <i className="mb15 block fs14">
                Posted a job before? We recommend using the same email address.
                </i>
              </small>
              <div className="form-group">
                <input type="text" className="form-control mt15" id="email_address"
                  name="email_address"
                  placeholder="Enter an email address"
                  defaultValue={this.state.emailAddress}
                  onChange={this.handleEmailAddressChange}
                  disabled={this.state.isEmailDisabled}
                />
              </div>
            </div>
          }
          { Job.Data.omniAuthDetails['oauth_email_exists'] === true && <JobWizard.Password onRequest={this.props.onRequest} onRequestCompletion={this.props.onRequestCompletion}/> }
          { Job.Data.omniAuthDetails['account_from_omni_auth'] === false &&
            <div>
              { this.state.existingUser && <JobWizard.Password onRequest={this.props.onRequest} onRequestCompletion={this.props.onRequestCompletion} /> }
              { this.state.newUser && <JobWizard.CreateAccount /> }
            </div>
          }
        </div>
      )
    }
  })
}
